import { B2BUsersApi } from '@/gen/ecom/apis'
import { ecomConfiguration } from './apiConfigs'

export const b2bUsersClient = new B2BUsersApi(ecomConfiguration)
